// https://stackoverflow.com/questions/879152/how-do-i-make-javascript-beep
var audioCtx = new (window.AudioContext || window.webkitAudioContext || window.audioContext);

/******************************************************************************
 * SoundUtils Class
 * version: 1.0.1, release: 07.09.2018
 * author: albert lang, albert@jumptomorrow.com
 * ----------------------------------------------------------------------------
 * description:
 * 
 * dependencies: none
 * 
 * todos:
 * 
 *
 * //All arguments are optional:

//duration of the tone in milliseconds. Default is 500
//frequency of the tone in hertz. default is 440
//volume of the tone. Default is 1, off is 0.
//type of tone. Possible values are sine, square, sawtooth, triangle, and custom. Default is sine.
//callback to use on end of tone

******************************************************************************/


//============================================================================= SoundUtils Class
export default class SoundUtils {

	static beep = (duration=90, frequency=745, volume=0.5, type='sine', callback) => {
		if (!audioCtx) return null;
		
		var oscillator = audioCtx.createOscillator();
		var gainNode = audioCtx.createGain();
	
		oscillator.connect(gainNode);
		gainNode.connect(audioCtx.destination);
	
		gainNode.gain.value = volume;
		oscillator.frequency.value = frequency;
		oscillator.type = type;
		oscillator.onended = callback;
	
		oscillator.start(audioCtx.currentTime);
		oscillator.stop(audioCtx.currentTime + duration / 1000);
		return oscillator;
	};
}

